import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { useRouter } from "next/router";
import attorneys from "../../../public/attorneys.json";

export default function AttorneyDropDown(props) {
  const closeRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const router = useRouter();

  const handleClick = (e, slug) => {
    setSelectedItem(e);
    setIsClicked(true);
    setIsOpen(false);
    router.push(slug);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (closeRef.current && !closeRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeRef]);

  useEffect(() => {
    attorneys.forEach((attorney) => {
      const href = `/attorneys/${
        attorney.substring(0, 1) == "j"
          ? attorney.split(", ")[0].split(" ").pop()
          : attorney.split(" ").pop()
      }`;
      if (router.pathname === href) {
        setSelectedItem(attorney.toUpperCase());
        setIsClicked(true);
      }
    });
  }, [router.pathname]);

  const getAttorneySlug = (attorney) => {
    return `/attorneys/${
      attorney.substring(0, 1) == "j"
        ? attorney.split(", ")[0].split(" ").pop()
        : attorney.split(" ").pop()
    }`;
  };

  return (
    <DropDown ref={closeRef} size={props?.size} padding={props?.padding}>
      <div
        className="drop-down__header"
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen(!isOpen);
          }
        }}
      >
        <div
          className={`drop-down__header__title ${
            isOpen ? "open" : isClicked ? "clicked" : ""
          }`}
        >
          {isClicked ? <p>{selectedItem}</p> : <p>{props.title}</p>}
        </div>
        <div className="drop-down__header__arrow">
          <DropDownArrow
            className={isOpen ? "open" : isClicked ? "clicked" : ""}
          />
        </div>
      </div>
      <ul className={`drop-down__body ${isOpen ? "open" : ""}`}>
        {attorneys.map((attorney, index) => {
          return (
            <li
              className="drop-down__body__item"
              key={index}
            >
              <button
                type="button"
                onClick={() =>
                  handleClick(attorney.toUpperCase(), getAttorneySlug(attorney))
                }
              >
                {attorney.toUpperCase()}
              </button>
            </li>
          );
        })}
      </ul>
    </DropDown>
  );
}

const DropDownArrow = styled.span`
  font-size: 14px;
  color: #000000;
  transition: transform 0.5s ease-in-out;
  margin-bottom: 0;
  &::before {
    content: "";
    display: inline-block;
    border-top: 7px solid #808080;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    vertical-align: middle;
  }
  &.open::before {
    border-top: 7px solid #c293ff;
  }
  &.clicked::before {
    content: "";
    border-top: none;
    border-bottom: 7px solid #67318d;
  }
`;
const DropDown = styled.div`
  width: 100%;
  height: 42px;
  max-width: 492px;
  position: relative;

  .drop-down__header {
    width: 100%;
    height: 42px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    cursor: pointer;
    background-color: #ffffff;
  }
  .drop-down__header__title {
    & p {
      width: 100%;
      font-style: normal;
      font-weight: 400;
      font-size: 19px;
      line-height: 30px;
      color: #5f5f5f;
    }
    &.open {
      & p {
        color: #67318d;
      }
    }
    &.clicked {
      & p {
        color: #67318d;
      }
    }
  }
  .drop-down__header__arrow {
    margin: 0;
    font-size: 14px;
    transition: transform 0.2s ease-in-out;
    .open {
      transform: rotate(180deg);
    }
  }
  .drop-down__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    position: absolute;
    top: 42px;
    left: 0;
    width: 100%;
    overflow-y: auto;
    z-index: 2;
    opacity: 0;
    pointer-events: none;
    transition: transform 0.5s ease-in-out, opacity 0.5s;
    box-shadow: 0 2px 6px 2px rgba(0, 0, 0, 0.1);
    list-style: none;
    padding: 0;
    margin: 0;

    &.open {
      pointer-events: all;
      opacity: 1;
    }
  }
  .drop-down__body__item {
    padding: 0.75rem 1.5rem;
    font-style: normal;
    font-size: 19px;
    line-height: 30px;
    color: #808080;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
    list-style: none;
    width: 100%;
    text-align: left;
    & button {
      width: 100%;
      text-align: left;
      color: inherit;
      font-size: inherit;
      line-height: inherit;
      text-decoration: none;
      border: none;
      background: transparent;
      padding: 0;
      cursor: pointer;
    }

    :hover {
      color: #c293ff;
    }
  }

  @media (max-width: 700px) {
    .drop-down__header__title {
      & p {
        font-size: 14px;
        line-height: 24px;
      }
    }
    .drop-down__body__item {
      font-size: 16px;
      line-height: 24px;
      padding: 0.6rem 1.2rem;
    }
  }

  @media (max-width: 400px) {
    .drop-down__header__title {
      & p {
        font-size: 12px;
        line-height: 20px;
      }
    }
    .drop-down__body__item {
      font-size: 12px;
      line-height: 20px;
    }
  }
`;
